<template>
  <div class="page-center screen-medium" style="min-width:775px;z-index: 45;" :class="{ details_layout: selectedMatchAllBet }" :style="{ 'width': center_widthPX + 'px' ,'height': LeftMenu_heightPX + 'px' }">
    <template v-if="!selectedMatchAllBet && !liveSchedule">
      <sportTable></sportTable>
    </template>
    <template v-else-if="selectedMatchAllBet && !liveSchedule">
      <allBetCommon></allBetCommon>
    </template>
    <template v-else-if="selectedMatchAllBet && liveSchedule">
      <livetvEventsList></livetvEventsList>
    </template>
    <!-- <template v-else-if="!selectedMatchAllBet && !liveSchedule && hotSchedule">
      <sportTable></sportTable>
    </template> -->
  </div>
</template>

<script>
// import contentsRight from '../contentsRight/index'
import allBetCommon from '../../sport/allBetCommon'
import sportTable from '../../sport/sportTable'
import livetvEventsList from '../../livetv/livetvEventsList'

import {
  mapGetters
} from 'vuex'

export default {
  components: {
    // contentsRight,
    // contentHeader,
    sportTable,
    allBetCommon,
    livetvEventsList,
  },
  data() {
    return {
      heightPX: window.innerHeight + 'px',
      widthPX:  '775px',
    }
  },
  computed: {
    ...mapGetters([
      // 'oddSelected',
      'selectedTab',
      'selectedBettype',
      'selectedMatchAllBet',
      'liveSchedule',
      'resizeWHeight',
      'bool_leagueToggle',
      'unfold_AllSc',
      'miniNormal',
      'frameWidthHeight',
      'hotSchedule',
    ]),
    LeftMenu_heightPX: function () {
        return this.$store.getters.frameWidthHeight.height.currentHeight-100
    },
    center_widthPX: function () {
        return this.$store.getters.frameWidthHeight.width.CenterPage_current
    },
  },
  watch: {
    resizeWHeight() {
      var hgt = this.$store.getters.resizeWHeight
      if(this.$store.getters.bool_leagueToggle){
        hgt = hgt - 100
      }
      this.heightPX = hgt + 'px'
    },
    bool_leagueToggle(){
      //toggle open league box
      if(this.$store.getters.bool_leagueToggle){
        var ht = window.innerHeight - 100
        this.heightPX = ht + 'px'
      }
    }
  },
  methods: {
  },
  beforeMount() {
  },
  mounted() {
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsMain/centerContent.vue